export default "__VITE_ASSET__de2d3e75__"